<template>
  <div class="source-content-tabs">
    <div class="source-types">
      <button
        class="btn btn-link btn-sm tab-btn--outlined"
        :class="{
          active: selectedTab === 'new',
        }"
        data-test="producer-assets-newPollsTab"
        @click="selectedTab = 'new'"
      >
        New
      </button>

      <button
        class="btn btn-link btn-sm tab-btn--outlined"
        :class="{
          active: selectedTab === 'classic',
        }"
        data-test="producer-assets-classicPollsTab"
        @click="selectedTab = 'classic'"
      >
        Classic
      </button>
    </div>

    <keep-alive>
      <component :is="currentTabComponent" />
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: 'PollTabs',
  data() {
    return {
      selectedTab: 'new',
    };
  },
  computed: {
    currentTabComponent() {
      switch (this.selectedTab) {
        case 'classic':
          return () => import('../SmartPanels.vue');
        default:
          return () => import('./Polls.vue');
      }
    },
  },
};
</script>
